import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

export default function Footer() {
    const navigate = useNavigate();
    const { translations } = useLanguage();
    const t = translations.policies || {};

    const handleClick = (lat, lng, locationName) => {
        const today = new Date();
        today.setDate(today.getDate() + 3);
        const formattedToday = today.toISOString().split('T')[0];

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const formattedTomorrow = tomorrow.toISOString().split('T')[0];

        const params = new URLSearchParams();
        
        // Temel parametreleri ekle
        params.set('locationName', locationName);
        params.set('checkIn', formattedToday);
        params.set('checkOut', formattedTomorrow);
        params.set('nation', 'TR');
        params.set('lat', lat);
        params.set('lng', lng);
        
        // Occupancies bilgisini ekle
        const occupancies = [{
            rooms: 1,
            adults: 2,
            children: 0,
            paxes: []
        }];
        localStorage.setItem('locationName', locationName);
        // Occupancies'i JSON string olarak URL'e ekle
        params.set('occupancies', JSON.stringify(occupancies));
        // Hotels sayfasına yönlendir
        navigate(`/hotels?${params.toString()}`);
        window.location.reload();
    };

    return (
        <>
            <footer>
                <div className="container">
                    <div className="footer-top">
                        <div className="row row-cols-lg-5 row-cols-md-3 row-cols-sm-2 row-cols-1">
                            <div className="col">
                                <div className="footer-widget">
                                    <h5>Pages</h5>
                                    <ul className="footer-menu">
                                        <li>
                                            <a href="/">Home</a>
                                        </li>
                                        <li>
                                            <a href="/about">About</a>
                                        </li>
                                        <li>
                                            <a href="/contact">Contact</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-widget">
                                    <h5>Booking</h5>
                                    <ul className="footer-menu">
                                        <li>
                                            <a onClick={() => handleClick(41.0609, 28.9863)}>Hotels</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-widget">
                                    <h5>Marmara Region</h5>
                                    <ul className="footer-menu">
                                        <li>
                                            <a onClick={() => handleClick(41.0609, 28.9863, 'Istanbul')}>Istanbul</a>
                                        </li>
                                        <li>
                                            <a onClick={() => handleClick(40.2081, 29.0367, 'Bursa')}>Bursa</a>
                                        </li>
                                        <li>
                                            <a onClick={() => handleClick(40.7657, 29.9406, 'Kocaeli')}>Kocaeli</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-widget">
                                    <h5>Aegean Region</h5>
                                    <ul className="footer-menu">
                                        <li>
                                            <a onClick={() => handleClick(38.4192, 27.1287, 'Izmir')}>Izmir</a>
                                        </li>
                                        <li>
                                            <a onClick={() => handleClick(40.9781, 27.5112, 'Tekirdağ')}>Tekirdağ</a>
                                        </li>
                                        <li>
                                            <a onClick={() => handleClick( 37.0344, 27.4303, 'Muğla')}>Muğla</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-widget">
                                    <h5>Mediterranean Region</h5>
                                    <ul className="footer-menu">
                                        <li>
                                            <a onClick={() => handleClick(36.8841, 30.7056, 'Antalya')}>Antalya</a>
                                        </li>
                                        <li>
                                            <a onClick={() => handleClick(36.7993, 34.6399, 'Mersin')}>Mersin</a>
                                        </li>
                                        <li>
                                            <a onClick={() => handleClick(37.5736, 36.9371, 'Kahramanmaraş')}>Kahramanmaraş</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ justifyContent:'space-between', alignItems:'center' }}>
                            <div style={{ padding:'20px' }} className="col-md-3">
                                <div className="row align-items-center">
                                    <div className="col-lg-12 col-xl-12 col-xxl-12">
                                        <div className="text-xl-start mb-3 text-center">
                                            <a href="index.html" className="d-block footer-logo-light">
                                                <img src="/assets/logo-1.png" alt="logo"/>
                                            </a>
                                            <a href="index.html" className="footer-logo-dark">
                                                <img src="/assets/logo-1.png" alt="logo"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3" style={{ textAlign:'center' }}>
                                <img src="/assets/img/master-visa-troy.png" width={150} alt="master-visa-troy"/>
                            </div>
                        </div>
                        <div className="footer-img">
                            <img src="assets/img/bg/footer.svg" className="img-fluid" alt="img"/>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    <p className="fs-14">Copyright &copy; 2025. All Rights Reserved, <a target='_blank' href="https://bew.com.tr/"
                                            className="text-primary fw-medium">BEW YAZILIM</a></p>
                                   
                                    {/* Politika Linkleri */}
                                    <div className="policy-links">
                                        <ul className="list-inline mb-0">
                                            <li className="list-inline-item">
                                                <a href="/privacy-policy" className="fs-14 text-gray-6">
                                                    {t.privacy?.breadcrumb?.title || 'Privacy Policy'}
                                                </a>
                                            </li>
                                            <li className="list-inline-item">
                                                <span className="text-gray-6 mx-1">|</span>
                                            </li>
                                            <li className="list-inline-item">
                                                <a href="/cookie-policy" className="fs-14 text-gray-6">
                                                    {t.cookie?.breadcrumb?.title || 'Cookie Policy'}
                                                </a>
                                            </li>
                                            <li className="list-inline-item">
                                                <span className="text-gray-6 mx-1">|</span>
                                            </li>
                                            <li className="list-inline-item">
                                                <a href="/cancellation-policy" className="fs-14 text-gray-6">
                                                    {t.cancellation?.breadcrumb?.title || 'Cancellation Policy'}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
